import { Table } from "antd";
import { getTicketUsableCntToPriceCsvData, reportTicketUsableCntToPriceColumns, useGetReportTicketUsableCntToPrice } from "./model";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { RootState } from "../../../../modules";
import SuperAdminPassword from "../../../../components/SuperAdminPassword";

const UsableCntToPrice = () => {
    const { data, isFetching } = useGetReportTicketUsableCntToPrice();
    const { isSuperAdmin } = useSelector((state: RootState) => state.superAdmin);
    if (!isSuperAdmin) {
        return <SuperAdminPassword />
    }

    return <>
        <div style={{ fontSize: '16px', fontWeight: 700, marginBottom: '24px' }}>
            잔여 횟수-금액 전환
        </div>

        <div style={{ textAlign: 'right', marginBottom: '24px' }}>
            {data && <CSVLink style={{ border: "1px solid #B8B8B8", padding: "6.5px 15px", borderRadius: "6px", color: "black" }} filename={"잔여횟수-금액전환-" + dayjs().format("YYYY-MM-DD HH_mm_ss")} data={getTicketUsableCntToPriceCsvData(data)}>CSV 다운로드</CSVLink>}
        </div>
        <Table dataSource={data} rowKey={"wellnessTicketId"} columns={reportTicketUsableCntToPriceColumns} loading={isFetching} size='small' pagination={{ showSizeChanger: true }} />
    </>
}

export default UsableCntToPrice;